import styled from 'styled-components';
import theme from 'src/theme';

export const ErrorText = styled.div`
    color: ${theme.legacyColors.errorText};
    margin-top: 1rem;
`;

export const SoftErrorText = styled.div`
    color: ${theme.legacyColors.softErrorText};
    font-weight: 500;
    font-size: larger;
`;
